import { fromJS } from 'immutable';

export default {
    setSecurities: (state, products) => {
        return state.setIn(['list'], fromJS(products)).set('initialized', true);
    },
    updateSecurities: (state, products) => {
        return state.mergeIn(['list'], fromJS(products));
    },
    setSecurityDetails: (state, productId, product) => {
        return state.setIn(['list', productId], fromJS(product));
    },
    updateSecurityStatus: (state, productId, status) => {
        return state.setIn(['list', productId, 'state'], status);
    },
    switchSecurityMaster: (state, productId, masterId) => {
        return state.setIn(['list', productId, 'userMasterId'], masterId);
    },
    dissociateUserFromSecurity: (state, productId, userId) => {
        if (state.getIn(['list', productId, 'userMasterId']) === userId) {
            state = state.deleteIn(['list', productId, 'userMasterId']);
        }
        return state.deleteIn(['list', productId, 'usersList', state.getIn(['list', productId, 'usersList']).findIndex(i => i === userId)]);
    },
    dissociateUserFromSecurityAndSwitchMaster: (state, productId, userId, masterId) => {
        state = state.setIn(['list', productId, 'userMasterId'], masterId);
        return state.deleteIn(['list', productId, 'usersList', state.getIn(['list', productId, 'usersList']).findIndex(i => i === userId)]);
    }
};



// WEBPACK FOOTER //
// ./environments/myfhe/data/Security/core.js